export const MenuIdSettings = 'SETTINGS' as const;
